module.exports = __webpack_public_path__ + "img/setting.13fe2b5e.png";